/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * POSTs instructor MCQ report feedback to Berlin BER API (3.0/feedback).
 * @file AetMcqFeedbackService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import env from '../../../common/env';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class AetMcqFeedbackService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.AET_MCQ_FEEDBACK_REQUESTED, 'aetMcqFeedbackStatus');
  }

  handleEvent(eventName, eventData = {}) {
    const { feedbackBody } = eventData;
    const headerParams = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-berlin-tenant-id': env.BERLIN.TENANT_ID,
        'x-berlin-tenant-key': env.BERLIN.TENANT_KEY
      }
    };
    return this.getClient('berlin').post('/3.0/feedback', feedbackBody, headerParams);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    Framework.getEventManager().publish(
      AET_STORE_EVENTS.AET_MCQ_FEEDBACK_COMPLETED,
      { data: response?.data, eventData }
    );
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.AET_MCQ_FEEDBACK_FAILED, error);
  }
}
